import { useMemo } from 'react';
import { useGetEditOrActual } from '../../../../../state/CampaignSettings/selectors/useGetEditOrActual';

export const useTriggerSelector = () => {
  const state = useGetEditOrActual();
  return useMemo(() => state.trigger, [state.trigger]);
};
